export default __webpack_public_path__ + "static/media/logoclean.d608ba9c.svg";